import { Link } from "react-router-dom";
import SEO from "./SEO";
import { SERVICE_PAGES, servicePath } from "./servicePages";
import "./styles/ServicePage.css";




function Services() {
  return (
    <main className="svc-page">
      <SEO
        path="/services"
        title="Appliance Repair Services: Refrigerator, Washer, Dryer, Oven | AT Appliance Repair"
        description="Residential and commercial repair for refrigerators, washers, dryers, dishwashers, stoves, ovens and wine coolers. Upfront pricing and a parts and labor warranty."
      />

      <h1>Appliance Repair Services in the Chicago Suburbs</h1>
      <p>
        AT Appliance Repair and Maintenance repairs the appliances your home and business depend on.
        Choose your appliance below to see common problems, brands we service and answers to frequent questions.
        All repairs include a 30-day parts and labor warranty.
      </p>

      <div className="svc-cta">
        <a className="svc-btn" href="tel:+13316004935">Call (331) 600-4935</a>
        <Link className="svc-btn svc-btn-alt" to="/contact">Schedule Service</Link>
      </div>

      <div className="svc-grid">
        {SERVICE_PAGES.map((s) => (
          <div className="svc-card" key={s.slug}>
            <h2 className="svc-card-title">
              <Link to={servicePath(s.slug)}>{s.name}</Link>
            </h2>
            <p>{s.summary}</p>
            <p><Link to={servicePath(s.slug)}>Learn more about {s.name.toLowerCase()}</Link></p>
          </div>
        ))}
      </div>

      <h2>Technicians you can rely on</h2>
      <p>
        We service all major brands, including Samsung, LG, GE, Whirlpool, Maytag, Bosch and Miele.
        Not sure which service you need? Call and describe the problem, or see
        <Link to="/serviceareas"> the cities we serve</Link>.
      </p>
    </main>
  );
}

export default Services;